import { AppThemeBase } from "@/themes/theme.types.ts";

export interface AppThemeSidebar extends AppThemeBase {
  menu: {
    base: string;
  };
}

export const sidebarTheme: AppThemeSidebar = {
  base: "",
  menu: {
    base: "bg-light/50",
  },
};
